import { useDemoRequest } from "@/components/feature/DemoRequest";

export default function FinalCTASection() {
  const { open } = useDemoRequest();
  return (
    <section className="relative py-20 md:py-28 bg-graphite-850 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-emerald-accent/5 via-transparent to-transparent" />
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Run Your Business <span className="text-emerald-accent">on StackMap?</span>
          </h2>
          <p className="text-base md:text-lg text-silver-300 mb-8 max-w-xl mx-auto">
            Book a personalized demo and see how StackMap can transform your operations.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={open} className="btn-primary w-full sm:w-auto text-center cursor-pointer">Book a Demo</button>
            <button onClick={open} className="btn-outline w-full sm:w-auto text-center">
              Request a Demo
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}